/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} External_Apis_Field_Base_Url_HintInputs */



/**
* | output |
* | --- |
* | "The https origin and optional path prefix of the API. Calls outside it are refused." |
*
* @param {External_Apis_Field_Base_Url_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const external_apis_field_base_url_hint = /** @type {((inputs?: External_Apis_Field_Base_Url_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<External_Apis_Field_Base_Url_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der https-Ursprung und optionale Pfad-Präfix der API. Aufrufe außerhalb davon werden abgewiesen.")
	return /** @type {LocalizedString} */ ("The https origin and optional path prefix of the API. Calls outside it are refused.")
});